/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Standards_LabelInputs */

const en_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standards`)
};

const fr_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`normes`)
};

const de_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standards`)
};

const it_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const ru_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандарты`)
};

const es_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estándares`)
};

const zh_cn2_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准`)
};

const ja_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基準`)
};

const hi_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मानकों`)
};

const pt_pt2_new_project_standards_label = /** @type {(inputs: New_Project_Standards_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrões`)
};

/**
* | output |
* | --- |
* | "Standards" |
*
* @param {New_Project_Standards_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_standards_label = /** @type {((inputs?: New_Project_Standards_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Standards_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_standards_label(inputs)
	if (locale === "de") return de_new_project_standards_label(inputs)
	if (locale === "it") return it_new_project_standards_label(inputs)
	if (locale === "ru") return ru_new_project_standards_label(inputs)
	if (locale === "es") return es_new_project_standards_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_standards_label(inputs)
	if (locale === "ja") return ja_new_project_standards_label(inputs)
	if (locale === "hi") return hi_new_project_standards_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_standards_label(inputs)
	return en_new_project_standards_label(inputs)
});